// src/api/emojiApi.ts

export const searchEmojis = async (query: string): Promise<string[]> => {
  try {
    const response = await fetch('/api/search-emojis', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.emojis;
  } catch (error) {
    console.error('Error searching emojis:', error);
    throw error;
  }
};